import React from 'react'
import { Route } from 'react-router-dom'
import { ProviderAdd } from './page/provider-add'
// import { ProviderAuthView } from './page/provider-auth-view'
// import { ProviderAuthList } from './page/provider-auth-list'
import { ProviderConnect } from './page/provider-connect'
import { ProviderConsentRequestList } from './page/provider-consent-request-list'
import { ProviderEdit } from './page/provider-edit'
import { ProviderList } from './page/provider-list'
import { ProviderDomainList } from './page/provider-domain-list'
import { ProviderJobList } from './page/provider-job-list'
import { ProviderHealth } from './page/provider-health'
import { PolicyFindingList } from './page/policy-finding-list'
import { CredentialNotificationList } from './page/credential-notification-list'
import { ProviderOrganizationRedirect } from './page/provider-organization-redirect'
import { ProviderLegacyRedirect } from './page/provider-legacy-redirect'
import { Delete } from '../../../../shared/page/page-delete'
import { useApiFormProvider, useApiListProvider } from '../../../../api-new/state/auth'
import { RecycleList } from '../../../../shared/recycle/recycle-list'

export const LayoutProvider = () => {
  return (
    <React.Fragment>
      {/* The staff pages were /admin/provider/...; emails already sent link there. */}
      <ProviderLegacyRedirect />

      <Route path="/admin/sso/connections" component={ProviderList} />
      <Route path="/admin/sso/connections/:providerID(\d+)" component={ProviderEdit} />

      <Route path="/admin/sso/connections/:deleteID(\d+)/delete">
        <Delete useApiForm={useApiFormProvider} titleParam="providerName" successPath="/admin/sso/connections" />
      </Route>

      <ProviderOrganizationRedirect />

      <Route path="/admin/sso/connections/add" component={ProviderAdd} />

      {/* Admin-consent (Entra) and domain-bound shared-app (Google Workspace)
          onboarding -- spec 18 / Task 5.3 -- lives beside add rather than
          nested under a provider since there is no row yet. */}
      <Route path="/admin/sso/connect" component={ProviderConnect} />

      {/* Every Microsoft admin-consent request (spec 2026-09-26): sent,
          copied, approved, expired, cancelled, replaced. */}
      <Route path="/admin/sso/consent-requests" component={ProviderConsentRequestList} />

      {/* Fleet-wide pages (spec 4.x SSO hardening) -- health, report-only
          findings, and expiry-notification history -- live alongside the
          provider list rather than nested under a single provider. */}
      <Route path="/admin/sso/health" component={ProviderHealth} />
      <Route path="/admin/sso/findings" component={PolicyFindingList} />
      <Route path="/admin/sso/notifications" component={CredentialNotificationList} />

      {/* Platform-wide Domains list (spec 7 / Task 14): every
          organization_domains row, with the sys-only ownership/override/
          transfer actions -- lives alongside the other fleet-wide pages
          above rather than nested under a single provider. */}
      <Route path="/admin/sso/domains" component={ProviderDomainList} />

      {/* Operator job admin (Task 21A) + platform notification recipients
          (Task 21B): GET /job, GET /job/:name/runs, POST /job/:name/run,
          plus the sys-scoped notification-recipient CRUD -- a fleet-wide
          page alongside the others above. */}
      <Route path="/admin/sso/jobs" component={ProviderJobList} />

      <Route path="/admin/sso/connections/recycle">
        <RecycleList useApiList={useApiListProvider} useApiForm={useApiFormProvider} field1="providerName" field2="displayName" />
      </Route>

      {/* <Route path="/admin/sso/connections/:providerID/auth/:providerID" component={ProviderAuthList} /> */}
      {/* <Route path="/admin/sso/connections/:providerID/auth/:providerID/view/:authProviderID" component={ProviderAuthView} /> */}
    </React.Fragment>
  )
}
